<div class="organizations-selection-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <img src="assets/images/svg/logo.svg" alt="Logo" width="229" height="50" />
    <h1 class="title">
      {{ 'Select an organization to continue' | translate }}
    </h1>
    <mat-selection-list #selectionList [multiple]="false">
      @for (org of organizations; track org.id) {
        <mat-list-item (click)="onSelect(org)"
          >{{ org.name }} <mat-icon class="ml-2">chevron_right</mat-icon></mat-list-item
        >
      }
    </mat-selection-list>
  </section>
</div>
